
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiDatabase as ObiDatabaseElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-database.js';
 
 
 

 
 export const ObiDatabase = createComponent({
   react: React,
   tagName: 'obi-database',
   elementClass: ObiDatabaseElement,
   events: {
     
   }
  });
 
 